import { render } from "./PropertyList.vue?vue&type=template&id=40ecb858&ts=true"
import script from "./PropertyList.vue?vue&type=script&lang=ts"
export * from "./PropertyList.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__